<template>
  <a-modal width="60%" :label-col="4" :wrapper-col="14" :visible="open" @ok="onOk" @cancel="onClose" @close="onClose">
    <a-card :bordered="false">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper" >
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item  prop="stage">
                  <span slot="label" ><a-tooltip>{{$t('学段')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                  <a-select :placeholder="$t('请选择')+$t('学段')" style="width: 100%" v-model="queryParam.stage" allowClear>
                    <a-select-option v-for="(item, index) in this.customDict.SchoolStageEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="  6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
          <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
            <img alt="example" style="width: 100%" :src="previewUrl" />
          </a-modal>
        </div>
        <!-- 操作 -->
        <div style="margin-bottom: 16px">
          <a-button type="primary" :disabled="this.limitNum" :loading="loading" @click="selectGoodsAll">
            全选
          </a-button>
          <a-button type="primary" :disabled="this.selectedRowKeys.length <= 0" :loading="loading" @click="reload">
            取消全部
          </a-button>
          <span style="margin-left: 8px">
            <template v-if="this.selectedRowKeys.length > 0">
              {{ `已选择 ${selectedRowKeys.length} 条` }}
            </template>
            <template v-if="this.limitNum">
               限制选择{{this.limitNum}}条
            </template>
          </span>
        </div>
        <!-- 数据展示 -->
      <a-table
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :customRow="loadCustomRow"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'checkbox', onSelect: onSelect,onSelectAll:onSelectAll}"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="stage" slot-scope="text, record">
          <custom-dict-tag :options="customDict.SchoolStageEnum" :value="record.stage"/>
        </span>
      </a-table>
    </a-card>
  </a-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {tableMixin} from '@/store/table-mixin'
import {listSchoolGrade, pageSchoolGrade} from "@/api/school/schoolGrade";


export default {
  name: 'CheckboxGradeSelectForm',
  props: {},
  components: {
    CustomDictTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      goodsType: undefined,
      activeKey: 'first',
      pageSizeOptions: ['10', '20', '50', '100'],
      limitNum: undefined,
      selectedRowKeys: [],
      selectedRows: [],
      categoryList: [],
      cateOptions: [],
      brandList: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      open: false,
      loading: false,
      total: 0,
      idText:null,
      schoolId: undefined,
      batchId: undefined,
      // 查询参数
      queryParam: {
        schoolId: null,
        stage: null,
        pageNum: 1,
        pageSize: 100
      },
      columns: [
        {
          title: this.$t('名称'),
          dataIndex: 'gradeName',
          align: 'left'
        },
        {
          title: this.$t('学段'),
          dataIndex: 'stage',
          scopedSlots: { customRender: 'stage' },
          align: 'center'
        },
        {
          title: this.$t('排序'),
          dataIndex: 'sort',
          align: 'center'
        },
        {
          title: this.$t('学校名称'),
          dataIndex: 'schoolName',
          align: 'center'
        },
      ]
    };
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    changeTab(index) {
      if (index == null) {
        index = undefined
      }
      this.activeKey = index
    },
    reload() {
      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    selectGoodsAll() {
      //查询该条件下所有的商品,
      listSchoolGrade(this.queryParam).then(response => {
        this.selectedRows = response.data;
        this.selectedRowKeys = this.selectedRows.map(e => e.id);
      })

      this.selectedRowKeys = [];
      this.selectedRows=[];
    },
    /**
     *
     * @param records
     * @param schoolId 学校,
     * @param batchId ds
     */
    openGoods(schoolId, batchId, records) {
      if (schoolId) {
        this.schoolId = schoolId
        this.queryParam.schoolId = schoolId;
      }
      if (batchId) {
        this.batchId = batchId
      }
      if (records) {
        this.selectedRowKeys = records
      }
      this.getList()
      this.open = true;
    },
    onOk() {
      //判断有没有选择,拿到列表里选择的
      this.open = false
      this.$emit('gradeSelect', this.batchId, this.selectedRowKeys);
      this.resetQueryForm()
      this.schoolId = null
      this.batchId = null

    },
    // 取消按钮
    cancel() {
      this.open = false
      this.schoolId = null
      this.batchId = null
      this.resetQueryForm()

    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询明星列表 */
    getList () {
      this.loading = true
      pageSchoolGrade(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    /** 重置按钮操作 */
    resetQueryForm() {
      this.selectedRowKeys= [];
      this.selectedRows= [];
      this.queryParam = {
        schoolId: null,
        stage: null,
        pageNum: 1,
        pageSize: 10
      }
    },
    resetQuery () {
      this.resetQueryForm()
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelect (record, selected, selectedRows) {
      //如果是选中,则判断是限制数量
      if (selected) {
        if (this.limitNum) {
          if (this.selectedRowKeys.length >= this.limitNum) {
            console.log('到达了限制数量,',this.limitNum)
            return false
          }
        }
        this.selectedRowKeys.push(record.id)
        if (record.children) {
          record.children.forEach(ch=>{
            this.selectedRowKeys.push(ch.id)
          })
        }
      } else {
        this.selectedRowKeys = this.selectedRowKeys.filter(e => e !== record.id);
        if (record.children) {
          record.children.forEach(ch=>{
            this.selectedRowKeys = this.selectedRowKeys.filter(e => e !== ch.id);
          })
        }
      }
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        this.selectedRowKeys = selectedRows.map(item => item.id)
      } else {
        this.selectedRowKeys = []
      }
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    loadCustomRow (record, index) {
      return {
        on: {
          click: () => {
            //判断是否有选择
            if (this.selectedRowKeys.includes(record.id)) {
              //删除此id
              this.onSelect(record, false, this.selectedRows)
            } else {
              this.onSelect(record, true, this.selectedRows)
            }
          },
        }
      }
    },
  }
}
</script>
